export class CustomRuntimeError extends Error {
	toString() {
		return this.message;
	}
}
